<template>
  <div class="informes">
    <ul class="informes--nav" @click="goTop">
      <li class="informes--navItem" @click="currentTab = 0" :class="{active : currentTab === 0}">
        Informes III
      </li>
      <li class="informes--navItem" @click="currentTab = 1" :class="{active : currentTab === 1}">
        Informes II
      </li>
      <li class="informes--navItem" @click="currentTab = 2" :class="{active : currentTab === 2}">
        Informes I
      </li>
    </ul>

    <ul class="informes--content">
      <li class="informes--contentItem" v-show="currentTab == 0">
        <h1 class="sectionTitle">Informes III</h1>
        <informes3/>
      </li>
      <li class="informes--contentItem" v-show="currentTab == 1">
        <h1 class="sectionTitle">Informes II</h1>
        <informes2/>
      </li>
      <li class="informes--contentItem" v-show="currentTab == 2">
        <h1 class="sectionTitle">Informes I</h1>
        <informes1/>
      </li>
    </ul>
  </div>
</template>

<script>
import Informes3 from '@/templates/_Informes3'
import Informes2 from '@/templates/_Informes2'
import Informes1 from '@/templates/_Informes1'

export default {
  name: 'Informes',
  data () {
    return {
      currentTab: 0
    }
  },
  components: {
    Informes3,
    Informes2,
    Informes1
  },
  methods: {
    goTop () {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }
}
</script>

<style>

</style>
